import { Box, Flex, Typography } from "@aircall/tractor";

import EvaluationEmptyViewImage from "@/assets/images/no_evaluation.svg?react";

import { EvaluationEmptyStateProps } from ".";
import { useTracking } from "./EvaluationEmptyState.hooks";

export function EvaluationEmptyState({
  title,
  children,
}: EvaluationEmptyStateProps) {
  useTracking();

  return (
    <Flex
      gap="40px"
      flexDirection="column"
      alignItems="center"
      data-test="empty-evaluation-state-section"
    >
      <Box
        maxW={{
          _: "500px",
          md: "400px",
          lg: "500px",
        }}
        w="100%"
      >
        <EvaluationEmptyViewImage />
      </Box>
      <Typography variant="bodyRegularM">{title}</Typography>
      {children}
    </Flex>
  );
}
